import styled from '@emotion/styled';
import { icon, mediaQueries, palette, srOnly } from '../../css';

export const SvgContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const StyledSvg = styled('svg')(
    () => ({
        display: 'inline-block',
    }),
    ({ aColor, size, tone = 'base' }) => {
        let style = {};
        if (aColor) {
            style.fill = palette(aColor, tone);
        }
        if (typeof size === 'string') {
            style = { ...style, ...icon.size[size] };
        } else {
            Object.keys(size).forEach(bp => {
                const values = icon.size[size[bp]];
                if (bp === 'default') {
                    style = { ...style, ...values };
                } else {
                    style[mediaQueries[bp]] = values;
                }
            });
        }
        return style;
    },
);

const StyledTitle = styled('span')(() => srOnly);

export { StyledSvg, StyledTitle };
